import { render, staticRenderFns } from "./BlendMaterialBox.vue?vue&type=template&id=51580208&scoped=true"
import script from "./BlendMaterialBox.vue?vue&type=script&lang=js"
export * from "./BlendMaterialBox.vue?vue&type=script&lang=js"
import style0 from "./BlendMaterialBox.vue?vue&type=style&index=0&id=51580208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51580208",
  null
  
)

export default component.exports